import React from 'react';
import PropTypes from 'prop-types';
import { range } from 'lodash';
import { Field, FormSection } from 'redux-form/immutable';
import { Input } from './index';
import { useTranslation } from 'react-i18next';

const Address = ({ name, streets, isEditable, validate }) => {
  const { t } = useTranslation();
  return <FormSection name={name}>
    <Field
      label={streets > 1 ? t('Adressrad 1') : t('Adress')}
      name="street"
      component={Input}
      isEditable={isEditable}
      validate={validate.street}
    />
    {streets > 1
      && range(2, streets + 1).map((streetNumber) => (
        <Field
          key={`street${streetNumber}`}
          label={`${t("Addressrad")} ${streetNumber}`}
          name={`street${streetNumber}`}
          component={Input}
          isEditable={isEditable}
          validate={validate.street}
        />
      ))}
    <Field
      label={t("Postnummer")}
      name="postalCode"
      component={Input}
      isEditable={isEditable}
      validate={validate.postalCode}
    />
    <Field
      label={t("Postort")}
      name="city"
      component={Input}
      isEditable={isEditable}
      validate={validate.city}
    />
  </FormSection>
}




Address.propTypes = {
  name: PropTypes.string,
  isEditable: PropTypes.bool,
  validate: PropTypes.shape({
    street: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.func),
      PropTypes.func,
    ]),
    postalCode: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.func),
      PropTypes.func,
    ]),
    city: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.func),
      PropTypes.func,
    ]),
    countryCode: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.func),
      PropTypes.func,
    ]),
  }),
  streets: PropTypes.number,
};

Address.defaultProps = {
  name: 'address',
  isEditable: true,
  validate: {},
  streets: 1,
};

export default Address;
